import { render, staticRenderFns } from "./AttachmentSelect.vue?vue&type=template&id=39492fbb"
import script from "./AttachmentSelect.vue?vue&type=script&lang=js"
export * from "./AttachmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39492fbb')) {
      api.createRecord('39492fbb', component.options)
    } else {
      api.reload('39492fbb', component.options)
    }
    module.hot.accept("./AttachmentSelect.vue?vue&type=template&id=39492fbb", function () {
      api.rerender('39492fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AttachmentSelect.vue"
export default component.exports